export default __webpack_public_path__ + "static/media/screen5.38677905.png";